import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

import api from "../service/api";
import { setError } from "../reducers/appSlice";

const ComboVisibilidad = ({
  value,
  onChange,
  name,
  error = false,
  helperText = null,
  fullWidth = false,
  disabled = false,
  required = false,
}) => {
  const dispatch = useDispatch();
  const [searching, setSearching] = useState(true);
  const [datos, setDatos] = useState([]);

  useEffect(() => {
    setSearching(true);
    api
      .obtenerVsibilidades()
      .then((res) => setDatos(res.data))
      .catch((e) => dispatch(setError(e.response?.data?.error)))
      .finally(() => setSearching(false));
  }, []);

  return (
    <FormControl
      variant="outlined"
      size="small"
      error={error}
      disabled={searching || disabled}
      fullWidth={fullWidth}
      required={required}
    >
      <InputLabel id={`${name}Label`}>Visibilidad</InputLabel>
      <Select
        labelId={`${name}Label`}
        id={name}
        name={name}
        label={`Visibilidad${required ? "*" : ""}`}
        value={value}
        onChange={(e) => onChange(e)}
      >
        <MenuItem value="">Seleccione</MenuItem>
        {datos.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.descripcion.toUpperCase()}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};

export default ComboVisibilidad;
